import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import Image from 'next/image';
import scrollTo from '../../components/functions/scrollTo';
import LazyLoad, { lazyload } from 'react-lazyload';
import ContactUsPart from './ContactUsPart';
import ImageSlider from './ImageSlider';
import CardPart from './CardPart';
import Why from '../../components/Why';
import SimpleSlider from '../../components/design/ProcessSlider';
import Proposal from './Proposal.js';
import DesignCalculator from './DesignCalculator.js';
import Platform from './Platform';

lazyload({
  width: '100%',
});
const Design = props => {
  const [title, setTitle] = useState('');
  const [showProposal, setShowProposal] = useState(false);
  const [showCalc, setShowCalc] = useState(false);
  // web design
  const [showDesign, setShowDesign] = useState(false);
  const [moreDesign, setMoreDesign] = useState(false);
  // print design
  const [showPrint, setShowPrint] = useState(false);
  const [morePrint, setMorePrint] = useState(false);
  // graphic design
  const [showGraphic, setShowGraphic] = useState(false);
  const [moreGraphic, setMoreGraphic] = useState(false);
  // art &  ilustration
  const [showArt, setShowArt] = useState(false);
  const [moreArt, setMoreArt] = useState(false);
  // logo &  branding
  const [showLogo, setShowLogo] = useState(false);
  const [moreLogo, setMoreLogo] = useState(false);
  const webDesign = React.createRef(),
    printDesign = React.createRef(),
    graphicDesign = React.createRef(),
    artAndIlustration = React.createRef(),
    logoAndBranding = React.createRef();
  const toogleShowMore = type => {
    switch (type) {
      case 'web':
        setMoreDesign(!moreDesign);
        break;
      case 'print':
        setMorePrint(!morePrint);
        break;
      case 'graphic':
        setMoreGraphic(!moreGraphic);
        break;
      case 'art':
        setMoreArt(!moreArt);
        break;
      case 'logo':
        setMoreLogo(!moreLogo);
        break;
      default:
        break;
    }
  };
  const stickyBar = () => {
    const bar = document.getElementById('bar');
    const bar_offset = bar.offsetTop;
    window.addEventListener(
      'scroll',
      function () {
        if (window.pageYOffset > bar_offset + 91) {
          bar.classList.add('sticky');
        } else {
          bar.classList.remove('sticky');
        }
      },
      false
    );
  };
  useEffect(() => {
    stickyBar();
  }, []);
  const scrollToPlatform = (platform_id, offset, close = false) => {
    hideAll();
    switch (platform_id) {
      case 'web-design':
        if (close) webDesign.current.show();
        break;
      case 'print-design':
        if (close) printDesign.current.show();
        break;
      case 'graphic-design':
        if (close) graphicDesign.current.show();
        break;
      case 'art-and-illustration':
        if (close) artAndIlustration.current.show();
        break;
      case 'logo-branding':
        if (close) logoAndBranding.current.show();
        break;
      default:
        break;
    }
    setTimeout(function () {
      scrollTo(platform_id, offset);
    }, 200);
  };
  const hideAll = () => {
    webDesign.current.hide();
    printDesign.current.hide();
    graphicDesign.current.hide();
    artAndIlustration.current.hide();
    logoAndBranding.current.hide();
  };
  return (
    <>
      <Head>
        <title>Design Services - Get Your Design | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/design" />
        <meta
          name="description"
          content="Elevate your brand with Prodigi's design services. From graphics to web design, we create visually appealing solutions based on your business needs."
        />
        <meta property="og:url" content="https://weprodigi.com/design" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Design Services - Get Your Design | Prodigi" />
        <meta
          property="og:description"
          content="Elevate your brand with Prodigi's design services. From graphics to web design, we create visually appealing solutions based on your business needs."
        />
      </Head>
      <main className={'bg-white'}>
        <style jsx global>{`
                    ::selection{
                        color:white;
                        background:#670F7A
                    }
                    .indent-20{
                        text-indent:20px
                    }
                    .transitionCutom{
                        transition 1s linear
                    }
                    .my-shadow{
                        box-shadow:5px 0px 5px 0px rgba(0,0,0,0.4)

                    }
                    .scroll-down-animation {
                        position:relative;
                        display: block;
                        opacity: 0;
                        transition: all 0.4s ease;
                        line-height: 0;
                        font-size: 0;
                        color: transparent;
                        margin-left: auto;
                        margin-right: auto;
                        width: 50px;
                        height: 48px;
                        background-size: 0 auto;
                        animation: pulse 1.5s 0s infinite normal ease forwards;
                        background-image: url("/images/icons/arrow-bottom-white-animation.svg");
                        background-repeat: no-repeat;
                        margin-top:-10px;
                        margin-bottom:-10px;

                    }
                    .scroll-down-animation:before, .scroll-down-animation:after {
                        content: " ";
                        position: absolute;
                        top: 0;
                        left: 0;
                        display: block;
                        width: 100%;
                        height: 100%;
                        background: url("/images/icons/arrow-bottom-white-animation.svg") no-repeat center top;
                        background-size: 100% auto;
                        

                    }
                    .scroll-down-animation:before {
                        animation: pulse 1.5s 0.25s infinite normal ease forwards;
                    }
                    .scroll-down-animation:after {
                        animation: pulse 1.5s 0.5s infinite normal ease forwards;
                        
                    }
                    :root{
                        --dark: #3B0247;
                        --light: #670F7A;
                
                    }
                    @-webkit-keyframes  pulse {
                        0% {
                            opacity: 0;
                            background-position: center top;
                            background-size: 0 auto;
                        }
                        10% {
                            opacity: 0;
                        }
                        50% {
                            opacity: 1;
                            background-size: 75% auto;
                        }
                        90% {
                            opacity: 0;
                        }
                        100% {
                            opacity: 0;
                            background-position: center bottom;
                            background-size: 0 auto;
                        }
                    }
                    .filterClose{
                        border-bottom: 1px solid rgb(0 0 0 / 5%);
                    }
                      .perspective-1000{
                        perspective:1000px;
                        display: inline-flex;
                        width: 154px;
                        height: 40px;
                       }
                      .perspective-1000 a{
                        transform-style: preserve-3d;
                        transform: translateZ(-0px);
                        transition: transform .25s;
                      }
                      span.contact a:before,
                        span a:after{
                        position: absolute;
                        content: "Find Us";
                        height: 40px;
                        width: 154px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border: 2px solid #8DC63F;
                        box-sizing: border-box;
                        border-radius: 5px;
                        color: #fff;
                        font-size:18px
                    }
                    span a:before{
                         background: #8DC63F;
                        transform: rotateY(0deg) translateZ(15px);
                    }
                    span a:after{
                        font-weight: 400;
                        color:#8DC63F;
                        transform: rotateX(90deg) translateZ(15px);
                    }
                    span a:hover{
                        transform: translateZ(-15px) rotateX(-90deg);
                    }
                    .image-container{
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        position: absolute;
                        bottom: 60px;
                    }
                    .main-image{
                        position: relative;
                        z-index: 150;
                     
                    }
                    .circles-container{
                        position: absolute;
                        background: var(--light);
                        width: 50%;
                        height: 50%;
                        transform: rotate(45deg);
                        top:15%;
                        left: 26%;
                        z-index: 1;
                        border-radius: 5%;
                        overflow: hidden;
                    }
                    .cicle-block{
                        position: absolute;
                        z-index: 2;
                        
            
                    }
                    .main-image-line,.main-image-grass{
                        position: absolute;
                        left: 0;
                    }
                    
            
                
            
                    .block-1{
                        top: -15px;
                        z-index: 4;
            
                    }
                    .block-2{
                        top: -15px;
                        left: 60px;
                        z-index: 2;
             
                    }
                    .block-3{
                        top: -15px;
                        left: 120px;
                           z-index: 4;
                    }
                    .block-4{
                        top: -15px;
                        left: 180px;
                    }
                    .block-5{
                        top: -15px;
                        left: 240px;
                        z-index: 4;
            
                    }
            
            
                    .block-6{
                        top: 30px;
                    }
                    .block-7{
                        top: 30px;
                        left: 60px;
                        z-index: 2;
            
                    }
                    .block-8{
                        top: 30px;
                        left: 120px;
                    }
                    .block-9{
                        top: 30px;
                        left: 180px;
                        z-index: 4;
            
                    }
                    .block-10{
                        top: 30px;
                        left: 240px;
            
                    }
            
            
                    .block-11{
                        top: 75px;
                    }
                    .block-12{
                        top: 75px;
                        left: 60px;
                        z-index: 3;
                    }
                    .block-13{
                        top: 75px;
                        left: 120px;
                        z-index: 4;
                    }
                    .block-14{
                        top: 75px;
                        left: 180px;
                    }
                    .block-15{
                        top: 75px;
                        left: 240px;
                        z-index: 3;
                    }
            
            
                    .block-16{
                        top: 120px;
                        z-index: 3;
                    }
                    .block-17{
                        top: 120px;
                        left: 60px;
                    }
                    .block-18{
                        top: 120px;
                        left: 120px;
                        z-index: 4;
                    }
                    .block-19{
                        top: 120px;
                        left: 180px;
                    }
                    .block-20{
                        top: 120px;
                        left: 240px;
                        z-index: 2;
                    }
            
            
            
            
                    .block-21{
                        top: 165px;
                    }
                    .block-22{
                        top: 165px;
                        left: 60px;
                    }
                    .block-23{
                        top: 165px;
                        left: 120px;
                        z-index: 2;
                    }
                    .block-24{
                        top: 165px;
                        left: 180px;
                        z-index: 4;
                    }
                    .block-25{
                        top: 165px;
                        left: 240px;
                        z-index: 2;
            
                    }
            
            
                    .block-26{
                        top: 210px;
                    }
                    .block-27{
                        top: 210px;
                        left: 60px;
                        z-index: 4;
                    }
                    .block-28{
                        top: 210px;
                        left: 120px;
                    }
                    .block-29{
                        top: 210px;
                        left: 180px;
                    }
                    .block-30{
                        top: 210px;
                        left: 240px;
                    }
            
            
                    .block-31{
                        top: 255px;
                    }
                    .block-32{
                        top: 255px;
                        left: 60px;
                        z-index: 4;
                    }
                    .block-33{
                        top: 255px;
                        left: 120px;
                    }
                    .block-34{
                        top: 255px;
                        left: 180px;
                        z-index: 5;
            
                    }
                    .block-35{
                        top: 255px;
                        left: 240px;
                        z-index: 3;
                    }
                     
            
            .cicle-one{
                        width: 75px;
                        height: 75px;
                        top: 0;
                        left: 0;
                     }
                    .cicle-two{
                        width: 60px;
                        height: 60px;
                        top: -67.5px;
                        left: 7.5px;
                     }
                    .circle-three {
                        width: 45px;
                        height: 45px;
                        top: -120.5px;
                        left: 14.5px;
             
                    }
                    .circle-four{
                        width: 30px;
                        height: 30px;
                        top: -158.5px;
                        left: 21.5px;
             
                    }
                    .circle-five{
                        width: 15px;
                        height: 15px;
                        top: -180.5px;
                        left: 29.5px;
            
                     }
                     .circle-six{
                        width: 5px;
                        height: 5px;
                        top: -190.5px;
                        left: 34.5px;
            
                     }
                     .circle-seven{
                        width: 3px;
                        height: 3px;
                        top: -194.5px;
                        left: 35.5px;
            
                     }
                    .circle-dark{
                        background:var(--dark);
                        border-radius: 50%;
                        position: relative;
                        z-index: 3;
                    }
                    .circle-light{
                        background:var(--light);
                        border-radius: 50%;
                        position: relative;
                        z-index: 3;
                    }
            
                    .circle-five,.circle-six,.circle-seven{
                       animation: ring-1 0.5s  ease-out infinite;
                    }
                    
                     @keyframes ring-1 {
                          0% {
                           transform: scale(1.0);
                           }
                           
                          100% {
                           transform: scale(1.3);
                           }
                    }
                    .zoomer{
                        position:absolute;
                        top:50%;
                        left:50%;
                        transform:translate(-50%,-50%);
                        width:100%;
                        height:100%;
                        animation:zoomer .5s infinite linear;
                    }
                    .one{
                        position:absolute;
                        width:calc(100% - 8px);
                        height:calc(100% - 8px);
                        background-color:#670e7a;
                        border-radius:50%;
                        top:50%;
                        left:50%;
                        transform:translate(-50%,-50%);
                        transition:all .3s;
                  }
                  .circle{
                       position:absolute;
                    width: 75px;
                    height: 75px;
                    padding-bottom: 25%;
                    background-color:var(--dark);
                    border-radius:50%;
                    overflow:hidden;
                    box-sizing:border-box;
                    transform-style: preserve-3d;
                    // /*transform: rotateX(70deg);*/
                  }
                  .two{
                    position:absolute;
                    width:calc(100% - 8px);
                    height:calc(100% - 8px);
                    background-color:var(--dark);
                    border-radius:50%;
                    top:50%;
                    left:50%;
                    transform:translate(-50%,-50%);
                    transition:all .3s;
                  }
                @keyframes zoomer{
                    0%{
                      width:100%;
                      height:100%;
                    }
                    100%{
                      width: calc(100% + 15px);
                      height: calc(100% + 15px);
                    }
                  }
                   

                  .animationBehance{
                    top: 130px;
                    transform: rotate(-12deg);
                    left:40px
                  }
               
                @font-face {
                    font-family: halvetica;
                    src: url('/fonts/Helvetica-Bold-Font.ttf');
                  }
               .text-animation > span {
                   position: relative;
                   top: 20px;
                   display: inline-block;
                   font-size: 30px;
                   font-family:halvetica;
                   color: #fff;
                   text-shadow: 0 1px 0 #8DC63F,
                       0 2px 0 #8DC63F,
                       0 3px 0 #8DC63F,
                       0 4px 0 #8DC63F,
                       0 5px 0 #8DC63F,
                       0 6px 0 transparent,
                       0 7px 0 transparent,
                       0 8px 0 transparent,
                       0 9px 0 transparent,
                       0 10px 10px rgba(0, 0, 0, 0.4);
                       animation: bounce .8s ease infinite alternate;
           
               }
                 .text-animation > span >span{
                     text-shadow: none;
                     font-size:22px
                 }
               .text-animation > span:nth-child(1) {
                   animation-delay: .05s;
           
               }
                .logo-line{
                    position: absolute;
                    top: -6px;
                    left: 3.5px;
                }
                @keyframes bounce {
                    100% {
                        top: -20px;
                        text-shadow: 0 1px 0 #8DC63F,
                            0 2px 0 #8DC63F,
                            0 3px 0 #8DC63F,
                            0 4px 0 #8DC63F,
                            0 5px 0 #8DC63F,
                            0 6px 0 #8DC63F,
                            0 7px 0 #8DC63F,
                            0 8px 0 #8DC63F,
                            0 9px 0 #8DC63F,
                            0 50px 25px rgba(0, 0, 0, 0.2);
                    }
                }
                @media screen and (max-width:758px){
                    .image-container {
                        bottom:0
                    }
                }
                    
                `}</style>
        <div className="intro relative  min-h-600 w-full h-auto md:h-intro lg:h-intro-md bg-gray-light bg-grid overflow-hidden">
          <div className="relative min-h-600 h-full md:flex md:items-center py-12p">
            <div className="container">
              <div className="relative z-10 flex flex-col flex-wrap justify-center items-start h-3/6 md:pb-90 md:mb-120 lg:mb-0 lg:pb-90">
                <h1 className="text-black md:text-purple uppercase font-black text-10vw md:text-72 leading-none">
                  DESIGN
                  <span className="block text-purple md:text-black">services </span>
                </h1>

                <a
                  onClick={() => {
                    setShowProposal(true);
                    setTitle('Design Services ');
                    document.documentElement.style.overflow = 'hidden';
                  }}
                  className="get-smm-proposal-button relative z-10 hidden md:inline-block border-2 rounded-5 border-purple text-18 text-purple px-23 mt-23 py-5 transition-all icon-paper-container transition-400 cursor-pointer overflow-hidden"
                >
                  <span className="icon icon-paper" />
                  <span className="text block">Get your design</span>
                </a>
              </div>
            </div>
            <div className="absolute w-full h-full top-auto left-0 bottom-0">
              <div className="ruller absolute left-0 bottom-0 z-10" />
              <div className="ruller ruller2 hidden md:block absolute left-auto top-0" />
              <div className="overlay absolute w-full md:w-1/3 h-2/6 md:h-full top-auto bottom-0 left-auto right-0 bg-purple">
                <div className="personage-container h-full ">
                  <div className="personage relatove h-full md:absolute w-100p  left-0 md:-left-200 md:w-4/5 lg:w-full h-auto bottom-0 md:right-0  z-10">
                    <div className="image-container w-full max-w-620">
                      <div className="circles-container">
                        {[...Array(35)].map((x, i) => (
                          <div className={`cicle-block block-${i + 1}`} key={i}>
                            <div className="circle">
                              <div className="zoomer">
                                <span className="one">
                                  <div className="two">
                                    <span className="one">
                                      <div className="two">
                                        <span className="one">
                                          <div className="two">
                                            <span className="one">
                                              <div className="two">
                                                <span className="one">
                                                  <div className="two">
                                                    <span className="one">
                                                      <div className="two">
                                                        <span className="one">
                                                          <div className="two" />
                                                        </span>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </span>
                                              </div>
                                            </span>
                                          </div>
                                        </span>
                                      </div>
                                    </span>
                                  </div>
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <img src="/images/design/main_image3_1.png" width="620" height="646" alt="personage1" className="main-image-line" />
                      <img src="/images/design/main_image2_1.webp" width="620" height="646" alt="personage2" className="main-image-grass" />
                      <picture className="z-10">
                        <source srcSet="/images/design/main_image1.webp" type="image/webp" />
                        <source srcSet="/images/design/main_image1_1.webp" type="image/png" />
                        <img src="/images/design/main_image1_1.webp" alt="personage3" width="620" height="646" />
                      </picture>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="bar" className="hidden md:flex flex-row bg-purple absolute justify-start py-15 bottom-0 w-full z-50">
            <div className="md:container md:px-0 flex flex-row justify-start">
              <div
                className="intro-link pl-20 w-100   justify-start items-center py-5 text-start text-16 md:text-13 lg:text-16 text-white hover:text-green transition-all border-r border-white flex-grow cursor-pointer"
                onClick={() => {
                  scrollToPlatform('web-design', 0, true);
                }}
              >
                Web Design
              </div>
              <div
                className="intro-link w-150  justify-center items-center py-5 text-center text-16 md:text-13 lg:text-16 text-white hover:text-green transition-all border-r border-white flex-grow cursor-pointer"
                onClick={() => {
                  scrollToPlatform('print-design', 0, true);
                }}
              >
                Print Design
              </div>
              <div
                className="intro-link  w-150 justify-center items-center py-5 text-center text-16 md:text-13 lg:text-16 text-white hover:text-green transition-all border-r border-white flex-grow cursor-pointer"
                onClick={() => {
                  scrollToPlatform('graphic-design', 0, true);
                }}
              >
                Graphic Design
              </div>
              <div
                className="intro-link w-150  justify-center items-center py-5 text-center text-16 md:text-13 lg:text-16 text-white hover:text-green transition-all border-r border-white flex-grow cursor-pointer"
                onClick={() => {
                  scrollToPlatform('art-and-illustration', 0, true);
                }}
              >
                Art & Illustration
              </div>
              <div
                className="intro-link  justify-center items-center py-5 text-right pr-20 text-16 md:text-13 lg:text-16 text-white hover:text-green transition-all    border-white flex-grow cursor-pointer"
                onClick={() => {
                  scrollToPlatform('logo-branding', 0, true);
                }}
              >
                Logo & Branding
              </div>
            </div>
          </div>
        </div>
        <div className="container text-16 leading-16  mt-30 md:mt-23 mb-0 ">
          <p>
            We are a full-service production agency that provides 100% custom design services for online & offline uses. We offer Web, Print, Graphic,
            Logo design and branding services for small-to medium size companies from various industries to fulfill their business needs such as
            marketing, sales, education, as well as for non-profit organizations working in the field of education, entertainment, and so on.
            WeProDigi creates unique designs that are not only beautiful and catchy, but are also purpose driven, as we are not only a design agency,
            but an agency with 8+ years of marketing experience. Our expertise in the field of marketing enables us to create targeted designs that
            not only solve your business problems but also ones that your target audience love to interact with.
          </p>
          <div className={''}>
            Our specialists make sure every designed item is rooted in making the user’s experience better. Below you can find more details about your
            preferred design type.
          </div>
          <div className=" mt-30 md:mt-0">
            <div
              onClick={() => {
                setShowProposal(true);
                setTitle('Design Services ');
                document.documentElement.style.overflow = 'false';
              }}
            >
              <a className="get-smm-proposal-button block md:hidden mt-20 border rounded-5 border-purple text-center text-18 text-purple px-23 py-5 hover:bg-purple hover:text-white transition-all icon-calculator-container transition-400">
                <span className="icon icon-calculator" />
                Get your design
              </a>
            </div>
          </div>
        </div>
        <>
          <div className="">
            <div className="" id="multiservices-section">
              {/*WEB design */}
              <Platform show={false} scrollToPlatform={scrollToPlatform} id="web-design" ref={webDesign} hideAll={hideAll}>
                <div className={'bg-gray-light pb-5 md:pb-30'}>
                  <div className="mt-30 container flex flex-wrap f-full">
                    <h2 className={'uppercase mt-30  w-full flex-grow text-purple font-black text-24 md:text-48'}>Web Design</h2>
                    <div className="w-full xl:w-half  pt-15 md:pt-20">
                      <div className=" mt-10 md:mt-0 text-16  color-black pr-0 md:pr-10">
                        It's no surprise that 95% of your user's first impression of your company comes from your website. Web design services can
                        greatly boost your company's bottom line. Building an attractive, fast, and easy-to-use website, landing page or mobile app
                        will help your business achieve your goals whether you want to drive online sales, generate qualified leads, or drive in-store
                        traffic.
                        <span className={` ${moreDesign ? 'inline' : 'hidden'} md:inline`}>
                          Small-to-midsize businesses (SMBs) trust us when it comes to developing a brand new website, redesigning an existing one,
                          designing mobile apps, landing pages, or web banners, as we helped 135+ companies to fulfill their business goals and obtain
                          an ideal lead generation funnel. As a professional website design company that has a rich expertise in the field, we are
                          offering a full range of services for web design. We offer everything your company needs to launch and maintain your web
                          needs: Custom, SEO-friendly, Responsive design.
                        </span>
                        <span className="inline-block   md:hidden text-purple  underline" onClick={() => toogleShowMore('web')}>
                          {' '}
                          {!moreDesign ? 'show more' : 'show less'}
                        </span>
                      </div>
                    </div>
                    <div className="w-full xl:w-half mt-10 md:-mt-10">
                      <div className="personage mt-0 md:mt-23  md:w-4/5 lg:w-full h-auto bottom-0 md:right-0  z-10">
                        <picture>
                          <source media="(min-width:768px)" srcSet="/images/design/web-design_main.webp" type="image/webp" />
                          <source media="(min-width:768px)" srcSet="/images/design/web-design_main.png" type="image/png" />
                          <source media="(max-width:768px)" srcSet="/images/design/web-design_main.webp" type="image/webp" />
                          <img width="748" height="398" src="" alt={'personage'} />
                        </picture>
                      </div>
                    </div>
                  </div>
                  <LazyLoad>
                    <div className=" mt-0 md:mt-30 flex p-20 md:p-0 flex-wrap justify-between container">
                      <CardPart
                        buttonText={'Use Calculator'}
                        title={'Web Design'}
                        checkItems={[
                          { title: 'Custom Design(Mockup, Design)' },
                          { title: 'Professional copywriting' },
                          { title: 'Optimized for SEO' },
                          { title: 'Responsive design' },
                          { title: 'Database integration' },
                          { title: ' CMS' },
                        ]}
                        haveMoreItems={false}
                        isPurple={true}
                        webp={'/images/design/web-design.webp'}
                        image={'/images/design/web-design.png'}
                        mobile={'/images/design/web-design.png'}
                        width={214}
                        height={214}
                        color="#670F7A"
                        order={1}
                        getProposal={() => {
                          setShowCalc(true);
                          document.documentElement.style.overflow = 'hidden';
                        }}
                      />
                      <CardPart
                        buttonText={'Get Proposal'}
                        title={'Mobile App Design'}
                        checkItems={[
                          { title: ' Research & Discovery' },
                          { title: 'Layouts and Wireframe' },
                          { title: ' Impactful calls to action (CTAs)' },
                        ]}
                        haveMoreItems={false}
                        isPurple={false}
                        webp={'/images/design/app_design.webp'}
                        image={'/images/design/app_design.png'}
                        mobile={'/images/design/app_design.png'}
                        width={193}
                        height={214}
                        color="#09af77"
                        order={2}
                        getProposal={() => {
                          setShowProposal(true);
                          document.documentElement.style.overflow = 'hidden';
                          setTitle('Mobile App Design');
                        }}
                      />
                      <CardPart
                        buttonText={'Order now'}
                        title={'LANDING PAGE DESIGN'}
                        checkItems={[
                          { title: ' Custom Design(Mockup, Design)' },
                          { title: 'Optimized For SEO' },
                          { title: 'Responsive Design' },
                          { title: 'Strong Focus On Conversions' },
                          { title: 'Impactful Calls To Action (CTAs)' },
                        ]}
                        haveMoreItems={false}
                        isPurple={false}
                        webp={'/images/design/landing-design.webp'}
                        image={'/images/design/landing-design.png'}
                        mobile={'/images/design/landing-design.png'}
                        width={214}
                        height={214}
                        color="#09af77"
                        order={4}
                        getProposal={() => {
                          setShowProposal(true);
                          document.documentElement.style.overflow = 'hidden';
                          setTitle('Landing Page Design');
                        }}
                      />
                    </div>
                  </LazyLoad>
                  <div className="container-fluid md:container   mt-0 md:mt-0">
                    <h2 className={'text-purple capitalize font-bolder p-20  md:p-0 pt-0 pb-0  text-18 md:text-24 leading-29   '}> some examples</h2>
                    <div className="mt-0 md:mt-30   md:p-0">
                      <ImageSlider
                        slides={[
                          {
                            icon: '/images/design/desktoppen.svg',
                            title: 'Dr. Smith Doe',
                            subtitle: 'Website Design',
                            image: '/images/design/smith.jpg',
                          },
                          {
                            icon: '/images/design/desktoppen.svg',
                            title: 'Arara Tour',
                            subtitle: 'Website Design',
                            image: '/images/design/adv.webp',
                          },
                          {
                            icon: '/images/design/image.svg',
                            title: 'SoftLand',
                            subtitle: 'Website Design',
                            image: '/images/design/softland.jpg',
                          },
                          {
                            icon: '/images/design/desktop1.svg',
                            title: 'Tutor Plus',
                            subtitle: 'Website Design',
                            image: '/images/design/tutor.jpg',
                          },
                          {
                            icon: '/images/design/mobile.svg',
                            title: 'Investing App ',
                            subtitle: 'App Design',
                            image: '/images/design/investing.jpg',
                          },
                          {
                            icon: '/images/design/mobile.svg',
                            title: 'House Mates',
                            subtitle: 'App Design',
                            image: '/images/design/housemates.jpg',
                          },
                        ]}
                      />
                    </div>
                  </div>
                </div>
                <div className=" bg-white relative z-10 flex justify-between overflow-hidden bg-text">
                  <ContactUsPart
                    question={'need another web design services?'}
                    link="https://calendar.app.google/uJZkJfztLwHZcfkC7"
                  />
                </div>
              </Platform>
              {/* print design  */}
              <Platform show={false} scrollToPlatform={scrollToPlatform} id="print-design" ref={printDesign} hideAll={hideAll}>
                <div>
                  <div className={'container-fluid md:container '}>
                    <LazyLoad>
                      <div className="mt-30 flex flex-wrap f-full  pt-0 pb-0 p-20 md:p-0">
                        <h2 className={'uppercase  w-full flex-grow text-purple font-black text-24 md:text-48'}>Print Design Services</h2>
                        <div className="w-full xl:w-half pt-0 md:pt-0 ">
                          <div className="mt-15 md:mt-30  text-16  color-black p-0  md:pr-10">
                            Here at WeProdigi, we ensure print design materials will meet your marketing and communication goals and be loyal to your
                            brand identity,as we are also a marketing agency that creates purpose driven designs for your business needs: custom
                            brochure, flyer, poster, catalogue etc.
                            <span className={` ${morePrint ? 'inline' : 'hidden'} md:inline`}>
                              Print design process will be easy-peasy for you with us. You just provide us with any relevant info about your brand and
                              concept. You can provide us with your own logos and pictures, or we can choose high-resolution images from our licensed
                              stock libraries. If you're beginning a new business and don't have a plan for brand development or overall identity,
                              that’s ok. Simply provide us with as many instructions or samples as you can, and our creative team will bring your idea
                              to life. Join the hundreds of small and medium companies who rely on Weprodigi for all of their design and printing
                              requirements.
                            </span>
                            <span className="inline-block   md:hidden text-purple  underline" onClick={() => toogleShowMore('print')}>
                              {' '}
                              {!morePrint ? 'show more' : 'show less'}
                            </span>
                          </div>
                        </div>
                        <div className="w-full xl:w-half ">
                          <div className="personage mt-0 md:-mt-15  md:w-4/5 lg:w-full h-auto bottom-0 md:right-0  z-10">
                            <picture>
                              <source media="(min-width:768px)" srcSet="/images/design/print-design_main3.png" type="image/webp" />
                              <source media="(min-width:768px)" srcSet="/images/design/print-design_main3.png" type="image/png" />
                              <source media="(max-width:768px)" srcSet="/images/design/print-design_main3.png" type="image/png" />
                              <img width="560" height="418" src="" alt={'personage'} />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </LazyLoad>
                  </div>
                  <LazyLoad>
                    <div className="mt-0 md:mt-30 flex p-20 md:p-0 flex-wrap justify-between container">
                      <CardPart
                        buttonText={'Order now'}
                        title={'FLYERS & BROCHURES'}
                        checkItems={[
                          { title: 'Brainstorming' },
                          { title: 'Structure For Flyer Or Brochure' },
                          { title: 'Initial Design' },
                          { title: 'Edits' },
                          { title: 'Final Delivery' },
                        ]}
                        haveMoreItems={false}
                        isPurple={true}
                        webp={'/images/design/flyer_print-design.webp'}
                        image={'/images/design/flyer_print-design-2.png'}
                        mobile={'/images/design/flyer_print-design.webp'}
                        width={208}
                        height={206}
                        color="#670F7A"
                        order={1}
                        getProposal={() => {
                          setShowProposal(true);
                          document.documentElement.style.overflow = 'hidden';
                          setTitle('Flyers & Brouchures');
                        }}
                      />
                      <CardPart
                        buttonText={'Order now'}
                        title={'POSTER'}
                        checkItems={[
                          { title: 'Research' },
                          { title: 'Main Idea' },
                          { title: 'Initial Design' },
                          { title: 'Edits' },
                          { title: 'Final Delivery' },
                        ]}
                        haveMoreItems={false}
                        isPurple={false}
                        webp={'/images/design/poster_print-design.webp'}
                        image={'/images/design/poster_print-design-1.png'}
                        mobile={'/images/design/poster_print-design.webp'}
                        width={190}
                        height={236}
                        color="#09af77"
                        order={2}
                        getProposal={() => {
                          setShowProposal(true);
                          document.documentElement.style.overflow = 'hidden';
                          setTitle('Posters');
                        }}
                      />
                      <CardPart
                        buttonText={'Order now'}
                        title={'MENU DESIGN'}
                        checkItems={[
                          { title: 'Conceptualization' },
                          { title: 'Layout Creation' },
                          { title: 'Adding Special Elements' },
                          { title: 'Cover Design' },
                          { title: 'Integrating Brand Identity' },
                        ]}
                        haveMoreItems={false}
                        isPurple={false}
                        webp={'/images/design/menu_art-and-illustration.webp'}
                        image={'/images/design/menu_art-and-illustration2.png'}
                        mobile={'/images/design/menu_art-and-illustration.webp'}
                        width={219}
                        height={213}
                        color="#09af77"
                        order={4}
                        getProposal={() => {
                          setShowProposal(true);
                          document.documentElement.style.overflow = 'hidden';
                          setTitle('Menu Design');
                        }}
                      />
                      <CardPart
                        buttonText={'Order now'}
                        title={'Catalogue & Magazine'}
                        checkItems={[
                          { title: 'Understanding Niche' },
                          { title: 'Prioritizing Content' },
                          { title: 'A Focus On Readability' },
                          { title: 'Branding Consistently' },
                          { title: 'Designing Responsively To Engage' },
                          { title: 'Insisting On Responsive Communication' },
                          { title: 'Ensure Prompt Delivery' },
                        ]}
                        whitespace={true}
                        haveMoreItems={true}
                        isPurple={true}
                        webp={'/images/design/catalogie_print-design1.webp'}
                        image={'/images/design/catalogie_print-design1.png'}
                        mobile={'/images/design/catalogie_print-design1.png'}
                        width={190}
                        height={236}
                        color="#670F7A"
                        order={3}
                        getProposal={() => {
                          setShowProposal(true);
                          document.documentElement.style.overflow = 'hidden';
                          setTitle('Catalogue & Magazine');
                        }}
                      />
                    </div>
                  </LazyLoad>
                  <div className=" container-fluid md:container   mt-0 md:mt-0">
                    <h2 className={'text-purple capitalize font-bolder  p-20 md:p-0 pt-0 pb-0   text-18 md:text-24 leading-29   '}> some examples</h2>
                    <div className="mt-0 md:mt-30   md:p-0">
                      <ImageSlider
                        slides={[
                          {
                            icon: '/images/design/flyer.svg',
                            title: 'Roxia',
                            subtitle: 'Brochure',
                            image: '/images/design/Untitled-6.jpg',
                          },
                          {
                            icon: '/images/design/flyer.svg',
                            title: 'Gracy',
                            subtitle: 'Brochure',
                            image: '/images/design/Untitled-7.jpg',
                          },
                          {
                            icon: '/images/design/book.svg',
                            title: 'Wild Australia',
                            subtitle: 'Magazine',
                            image: '/images/design/Untitled-8.jpg',
                          },
                          {
                            icon: '/images/design/book.svg',
                            title: 'TrailRun',
                            subtitle: 'Magazine',
                            image: '/images/design/Untitled-9.jpg',
                          },
                          {
                            icon: '/images/design/flyer.svg',
                            title: 'Ornate ',
                            subtitle: 'Flyer',
                            image: '/images/design/Untitled-10.jpg',
                          },
                          {
                            icon: '/images/design/flyer.svg',
                            title: 'Happyspace',
                            subtitle: 'Flyer',
                            image: '/images/design/Untitled-11.jpg',
                          },
                        ]}
                      />
                    </div>
                  </div>
                </div>
                <div className="mt-30 bg-white relative z-10 flex justify-between overflow-hidden bg-text">
                  <ContactUsPart
                    question={'need another print design services?'}
                    link="https://calendar.app.google/uJZkJfztLwHZcfkC7"
                  />
                </div>
              </Platform>
              {/* graphic design  */}
              <Platform show={false} scrollToPlatform={scrollToPlatform} id="graphic-design" ref={graphicDesign} hideAll={hideAll}>
                <div className={'bg-gray-light pt-30 pb-10 md:pb-30'}>
                  <div className={'container-fluid md:container '}>
                    <LazyLoad>
                      <div className="flex flex-wrap f-full p-20 pt-0 pb-0 md:p-0">
                        <h2 className={'uppercase  w-full flex-grow text-purple font-black text-24 md:text-48'}>Graphic Design Services</h2>
                        <div className="w-full xl:w-half pt-0  md:pt-0">
                          <div className="mt-15 md:mt-30  text-16  color-black p-0  md:pr-10">
                            Do you know why our graphic designing matters? Because we are always in the scope of following design trends, creating new
                            concepts that emerge, which enables us to create eye catchy and creative visual materials that fulfill brands goals. We
                            want your visual materials to be trendy & fulfill both your and your customers' expectations. Graphic design is our
                            speciality.
                            <span className={` ${moreGraphic ? 'inline' : 'hidden'} md:inline`}>
                              We would love to use it to empower you to stand out in yours. Weprodigi is the creative agency whose specialists are
                              experts of Adobe Illustrator, Photoshop, Indesign, Corel Draw and other advanced designing softwares. Our specialists
                              participate in creative festivals such as Cannes Lions, White square & etc, which help to develop creative mindset and
                              generate outstanding visual materials. We are ready to design creative and abiding materials which will catch the
                              attention of your target audience.
                            </span>
                            <span className="inline-block   md:hidden text-purple  underline" onClick={() => toogleShowMore('graphic')}>
                              {' '}
                              {!moreGraphic ? 'show more' : 'show less'}
                            </span>
                          </div>
                        </div>
                        <div className="w-full xl:w-half  ">
                          <div className="personage mt-0 md:-mt-22   md:w-4/5 lg:w-full h-auto bottom-0 md:right-0  z-10">
                            <picture>
                              <source media="(min-width:768px)" srcSet="/images/design/graphic-design_main.webp" type="image/webp" />
                              <source media="(min-width:768px)" srcSet="/images/design/graphic-design_main3.png" type="image/png" />
                              <source media="(max-width:768px)" srcSet="/images/design/graphic-design_main3.png" type="image/png" />
                              <img width="554" height="342" src="" alt={'personage'} />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </LazyLoad>
                    <LazyLoad>
                      <div className="mt-0 md:mt-30 p-20 md:p-0 flex flex-wrap justify-between container">
                        <CardPart
                          buttonText={'Order now'}
                          title={'3D Modeling'}
                          checkItems={[
                            { title: 'Analyzing Requirement' },
                            { title: 'Model Creation' },
                            { title: 'Customizing Models as per Client Needs' },
                            { title: 'Client Approval and Final Delivery' },
                          ]}
                          haveMoreItems={false}
                          isPurple={true}
                          webp={'/images/design/3d_graphic-design1.webp'}
                          image={'/images/design/3d_graphic-design1.png'}
                          mobile={'/images/design/3d_graphic-design1.png'}
                          width={214}
                          height={215}
                          color="#670F7A"
                          order={1}
                          getProposal={() => {
                            setShowProposal(true);
                            document.documentElement.style.overflow = 'hidden';
                            setTitle('3D Modelling');
                          }}
                        />
                        <CardPart
                          buttonText={'Order now'}
                          title={'Power Point\n' + 'Presentations'}
                          checkItems={[{ title: 'Presentation Structure' }, { title: 'Design' }, { title: 'Source Materials' }]}
                          haveMoreItems={false}
                          isPurple={false}
                          webp={'/images/design/ppt_graphic-design2.webp'}
                          image={'/images/design/ppt_graphic-design2.png'}
                          mobile={'/images/design/ppt_graphic-design2.png'}
                          width={213}
                          height={214}
                          color="#09af77"
                          order={2}
                          getProposal={() => {
                            setShowProposal(true);
                            document.documentElement.style.overflow = 'hidden';
                            setTitle('Power Point Presentations');
                          }}
                        />
                        <CardPart
                          buttonText={'Order now'}
                          title={'Retouching'}
                          checkItems={[
                            { title: 'Background removal/replacement' },
                            { title: 'Color correction' },
                            { title: 'Editing out shadows' },
                            { title: 'Ghost Mannequin technique' },
                            { title: 'Noise reduction' },
                            { title: 'Clipping path' },
                          ]}
                          haveMoreItems={false}
                          isPurple={false}
                          webp={'/images/design/retouch_graphic-design1.webp'}
                          image={'/images/design/retouch_graphic-design1.png'}
                          mobile={'/images/design/retouch_graphic-design1.png'}
                          width={213}
                          height={214}
                          color="#09af77"
                          order={4}
                          getProposal={() => {
                            setShowProposal(true);
                            document.documentElement.style.overflow = 'hidden';
                            setTitle('Retouching');
                          }}
                        />
                        <CardPart
                          buttonText={'Order now'}
                          title={'Social Media Design'}
                          checkItems={[{ title: 'Research' }, { title: 'Design' }, { title: 'AB Testing' }]}
                          whitespace={true}
                          haveMoreItems={false}
                          isPurple={true}
                          webp={'/images/design/smm_graphic-design1.webp'}
                          image={'/images/design/smm_graphic-design1.png'}
                          mobile={'/images/design/smm_graphic-design1.png'}
                          width={190}
                          height={236}
                          color="#670F7A"
                          order={3}
                          getProposal={() => {
                            setShowProposal(true);
                            document.documentElement.style.overflow = 'hidden';
                            setTitle('Social Media Design');
                          }}
                        />
                      </div>
                    </LazyLoad>
                  </div>
                  <div className=" container-fluid md:container   mt-0 md:mt-10">
                    <h2 className={'text-purple capitalize font-bolder p-20 md:p-0 pt-0 pb-0  text-18 md:text-24 leading-29   '}> some examples</h2>
                    <div className="mt-0 md:mt-30   md:p-0">
                      <ImageSlider
                        slides={[
                          {
                            icon: '/images/design/likes.svg',
                            title: 'KR',
                            subtitle: 'sm',
                            image: '/images/design/Untitled-12.jpg',
                          },
                          {
                            icon: '/images/design/likes.svg',
                            title: 'Desert Teleheart',
                            subtitle: 'sm',
                            image: '/images/design/Untitled-13.jpg',
                          },
                          {
                            icon: '/images/design/3d.svg',
                            title: 'GeoGroup',
                            subtitle: '3d',
                            image: '/images/design/Untitled-14.jpg',
                          },
                          {
                            icon: '/images/design/3d.svg',
                            title: 'Coolux',
                            subtitle: '3d',
                            image: '/images/design/Untitled-16.jpg',
                          },
                          {
                            icon: '/images/design/ppt.svg',
                            title: 'Noah Fest ',
                            subtitle: 'power point',
                            image: '/images/design/Untitled-15.jpg',
                          },
                          {
                            icon: '/images/design/ppt.svg',
                            title: 'Agenda',
                            subtitle: 'power point',
                            image: '/images/design/Untitled-17.png',
                          },
                        ]}
                      />
                    </div>
                  </div>
                </div>
                <div className=" bg-white relative z-10 flex justify-between overflow-hidden bg-text">
                  <ContactUsPart
                    question={'need another graphic design services?'}
                    link="https://calendar.app.google/uJZkJfztLwHZcfkC7"
                  />
                </div>
              </Platform>
              {/* art and ilustration */}
              <Platform show={false} scrollToPlatform={scrollToPlatform} id="art-and-illustration" ref={artAndIlustration} hideAll={hideAll}>
                <div>
                  <div className={'container-fluid md:container '}>
                    <LazyLoad>
                      <div className="mt-0 md:mt-30 flex flex-wrap f-full p-20 pt-0 pb-0 md:p-0">
                        <h2 className={'uppercase mt-30 md:mt-0  w-full flex-grow text-purple font-black text-24 md:text-48'}>Art & Illustration</h2>
                        <div className="w-full xl:w-half pt-0 md:pt-0 ">
                          <div className="mt-30 md:mt-30  text-16  color-black pr-0 md:pr-10">
                            Our illustration services are designed to meet all of your requirements, whether they are for digital, graphical,
                            technical, hand-drawn, or any other type. We can be your reliable destination and partner because we have a staff of
                            highly trained illustrators who are proficient at envisioning an idea from its genesis and transforming it into a
                            spectacular work of visuals.
                            <span className={` ${moreDesign ? 'inline' : 'hidden'} md:inline`}>
                              If you need ebook or book design, you will be offered at least two samples to select from, and once any revisions have
                              been approved, the design will be provided in a print-ready version or a high-resolution JPEG format, ready for upload.
                              You will also be provided a rendered 3D version of the cover to utilize for marketing purposes if necessary. We are a
                              respected illustration agency that handles a wide range of creative projects with over 8 years of combined experience in
                              the design and advertising industries. We can design every book or ebook cover you desire, as well as put a significant
                              emphasis on the visualization of your brand's character! And if you're not satisfied with any of the initial drafts, we
                              can edit it, and you don't have to pay a single penny.․
                            </span>
                            <span className="inline-block   md:hidden text-purple  underline" onClick={() => toogleShowMore('art')}>
                              {' '}
                              {!moreArt ? 'show more' : 'show less'}
                            </span>
                          </div>
                        </div>
                        <div className="w-full xl:w-half  ">
                          <div className="personage mt-0 md:mt-15   md:w-4/5 lg:w-full h-auto bottom-0 md:right-0  z-10">
                            <picture>
                              <source media="(min-width:768px)" srcSet="/images/design/art-and-illustration_main1.png" type="image/webp" />
                              <source media="(min-width:768px)" srcSet="/images/design/art-and-illustration_main1.png" type="image/png" />
                              <source media="(max-width:768px)" srcSet="/images/design/art-and-illustration_main1.png" type="image/png" />
                              <img width="586" height="452" src="" alt={'personage'} />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </LazyLoad>
                    <LazyLoad>
                      <div className="mt-0 md:mt-30 p-20 md:p-0 pt-0 pb-0  flex flex-wrap justify-between container">
                        <CardPart
                          buttonText={'Order now'}
                          title={'Book Cover'}
                          checkItems={[
                            { title: 'Cover design drafts' },
                            { title: 'A high resolution JPEG ready to upload' },
                            { title: 'A 3D rendering of cover for' },
                            { title: 'A layered Photoshop file of your cover' },
                            { title: 'Royalty-free stock images' },
                            { title: 'Facebook banners' },
                          ]}
                          haveMoreItems={true}
                          isPurple={true}
                          webp={'/images/design/book_art-and-illustration2.webp'}
                          image={'/images/design/book_art-and-illustration2.png'}
                          mobile={'/images/design/book_art-and-illustration2.png'}
                          width={231}
                          height={220}
                          color="#670F7A"
                          order={2}
                          getProposal={() => {
                            setShowProposal(true);
                            document.documentElement.style.overflow = 'hidden';
                            setTitle('Book Cover');
                          }}
                        />
                        <CardPart
                          buttonText={'Order now'}
                          title={'eBook Cover Design'}
                          checkItems={[
                            { title: '2 paperback cover design drafts' },
                            { title: 'A 3D rendering of cover for marketing purposes' },
                            { title: 'Print-ready PDF files' },
                            { title: 'A layered Photoshop file of your cover' },
                            { title: 'Royalty-free stock images' },
                            { title: 'Facebook banners' },
                          ]}
                          haveMoreItems={true}
                          isPurple={false}
                          webp={'/images/design/ebook_art-and-illustration2.webp'}
                          image={'/images/design/ebook_art-and-illustration2.png'}
                          mobile={'/images/design/ebook_art-and-illustration2.png'}
                          width={208}
                          height={220}
                          color="#09af77"
                          order={1}
                          getProposal={() => {
                            setShowProposal(true);
                            document.documentElement.style.overflow = 'hidden';
                            setTitle('eBook Cover Design');
                          }}
                        />
                        <CardPart
                          buttonText={'Order now'}
                          title={'Character Design'}
                          checkItems={[{ title: 'Concept Development' }, { title: 'Subject Oriented Sketching' }, { title: '2D or 3D Modelling' }]}
                          haveMoreItems={false}
                          isPurple={false}
                          webp={'/images/design/2character_art-and-illustration1.webp'}
                          image={'/images/design/2character_art-and-illustration1.png'}
                          mobile={'/images/design/2character_art-and-illustration1.png'}
                          width={226}
                          height={247}
                          color="#09af77"
                          order={3}
                          getProposal={() => {
                            setShowProposal(true);
                            document.documentElement.style.overflow = 'hidden';
                            setTitle('Character Design');
                          }}
                        />
                      </div>
                    </LazyLoad>
                  </div>
                  <div className=" container-fluid md:container   mt-0 md:mt-10">
                    <h2 className={'text-purple capitalize font-bolder p-20 md:p-0 pt-0 pb-0  text-18 md:text-24 leading-29   '}> some examples</h2>
                    <div className="mt-0 md:mt-30   md:p-0">
                      <ImageSlider
                        slides={[
                          {
                            icon: '/images/design/book3.svg',
                            title: 'Nhanam',
                            subtitle: 'book cover',
                            image: '/images/design/book.webp',
                          },
                          {
                            icon: '/images/design/book3.svg',
                            title: 'John Grisham',
                            subtitle: 'book cover',
                            image: '/images/design/book-2.webp',
                          },
                          {
                            icon: '/images/design/book3.svg',
                            title: 'Mark Daniels',
                            subtitle: 'book cover',
                            image: '/images/design/book-3.webp',
                          },
                          {
                            icon: '/images/design/ilustration.svg',
                            title: 'Antares',
                            subtitle: 'Illustration',
                            image: '/images/design/Untitled-25.png',
                          },
                          {
                            icon: '/images/design/book3.svg',
                            title: 'Make Me a Shining Light',
                            subtitle: 'Book Cover',
                            image: '/images/design/Untitled-24.png',
                          },
                          {
                            icon: '/images/design/book3.svg',
                            title: 'Marina Villatoro',
                            subtitle: 'Book Cover',
                            image: '/images/design/Untitled-26.png',
                          },
                        ]}
                      />
                    </div>
                  </div>
                  <div className="mt-30 bg-white relative z-10 flex justify-between overflow-hidden bg-text"></div>
                </div>
                <div className=" bg-white relative z-10 flex justify-between overflow-hidden bg-text">
                  <ContactUsPart
                    question={'need another art and ilustration services?'}
                    link="https://calendar.app.google/uJZkJfztLwHZcfkC7"
                  />
                </div>
              </Platform>
              {/* logo and branding */}
              <div className="relative" id={'logo-branding'}>
                <Platform show={false} scrollToPlatform={scrollToPlatform} id="logo-branding" ref={logoAndBranding} hideAll={hideAll}>
                  <div className={'bg-gray-light pt-0 pb-30'}>
                    <div className={'container-fluid md:container '}>
                      <LazyLoad>
                        <div className=" flex flex-wrap f-full  pt-0 pb-0 p-20 md:p-0">
                          <h2 className={'uppercase mt-30 w-full flex-grow text-purple font-black text-24 md:text-48'}>Logo & Branding</h2>
                          <div className="w-full xl:w-half  pt-0 md:pt-0">
                            <div className="mt-15 md:mt-30  text-16  color-black pr-0 md:pr-10">
                              You have succeeded to appear on one of the most experienced social media management company’s page. Due to our
                              comprehensive approach in developing customized and competitive social media marketing service plans, more than 350
                              companies have built brand awareness and generated revenue on social media platforms such as Facebook, Instagram,
                              LinkedIn and others.
                              <span className={` ${moreLogo ? 'inline' : 'hidden'} md:inline`}>
                                It comes true when you use our SMM services which include Strategy Development, Content Creation, Community
                                Management, Ads Management, Reporting and Analytics. Therefore, by choosing us you'll get a partner who is experienced
                                and certified in offering such services to small and medium-sized businesses in over 20 industries, including
                                healthcare, beauty and fashion, transportation, insurance, telecommunications, finance, construction, as well as
                                non-profit organizations working in education, entertainment, and other fields.
                              </span>
                              <span className="inline-block   md:hidden text-purple  underline" onClick={() => toogleShowMore('logo')}>
                                {' '}
                                {!moreDesign ? 'show more' : 'show less'}
                              </span>
                            </div>
                          </div>
                          <div className="w-full xl:w-half ">
                            <div className="personage mt-0 md:mt-10   md:w-4/5 lg:w-full h-auto bottom-0 md:right-0  z-10">
                              <picture>
                                <source media="(min-width:768px)" srcSet="/images/design/logo-design_main.webp" type="image/webp" />
                                <source media="(min-width:768px)" srcSet="/images/design/llogo-design_main3.png" type="image/png" />
                                <source media="(max-width:768px)" srcSet="/images/design/logo-design_main.webp" type="image/png" />
                                <img width="600" height="307.2" src="" alt={'personage'} />
                              </picture>
                            </div>
                          </div>
                        </div>
                      </LazyLoad>
                      <LazyLoad>
                        <div className="mt-0 md:mt-30 p-20  md:p-0 flex flex-wrap justify-between container">
                          <CardPart
                            buttonText={'Order now'}
                            title={'Logo Design'}
                            checkItems={[
                              { title: 'Unique logo concepts' },
                              { title: '1 finished, completely custom logo design' },
                              { title: 'The original, editable file (i.e. AI)' },
                              { title: 'Digital, print, web files (RGB, CMYK, PNG, JPEG, PDF)' },
                            ]}
                            haveMoreItems={false}
                            isPurple={true}
                            webp={'/images/design/logo_logo_branding.webp'}
                            image={'/images/design/logo_logo_branding1.png'}
                            mobile={'/images/design/logo_logo_branding.webp'}
                            width={236}
                            height={215}
                            color="#670F7A"
                            order={2}
                            getProposal={() => {
                              setShowProposal(true);
                              document.documentElement.style.overflow = 'hidden';
                              setTitle('Logo Design');
                            }}
                          />
                          <CardPart
                            buttonText={'Order now'}
                            title={'Business Card Design'}
                            checkItems={[
                              { title: '2 Design Options' },
                              { title: '3 Revisions' },
                              { title: 'The original, editable file (i.e. AI)' },
                              { title: 'Ready for print version' },
                            ]}
                            haveMoreItems={false}
                            isPurple={false}
                            webp={'/images/design/_cardslogo_branding.webp'}
                            image={'/images/design/_cardslogo_branding.webp'}
                            mobile={'/images/design/_cardslogo_branding.webp'}
                            width={202}
                            height={214}
                            color="#09af77"
                            order={1}
                            getProposal={() => {
                              setShowProposal(true);
                              document.documentElement.style.overflow = 'hidden';
                              setTitle('Business Card Design');
                            }}
                          />
                          <CardPart
                            buttonText={'Order now'}
                            title={'Car Wrap Design'}
                            checkItems={[
                              { title: 'Designs fit to any car' },
                              { title: 'Design preview on car' },
                              { title: 'Ready for print version' },
                              { title: 'The original, editable file (i.e. AI)' },
                            ]}
                            haveMoreItems={false}
                            isPurple={false}
                            webp={'/images/design/car_logo_branding.webp'}
                            image={'/images/design/car_logo_branding1.png'}
                            mobile={'/images/design/car_logo_branding.webp'}
                            width={236}
                            height={215}
                            color="#09af77"
                            order={3}
                            getProposal={() => {
                              setShowProposal(true);
                              document.documentElement.style.overflow = 'hidden';
                              setTitle('Car Wrap Design');
                            }}
                          />
                        </div>
                      </LazyLoad>
                    </div>
                    <div className=" container-fluid md:container   mt-0 md:mt-30">
                      <h2 className={'text-purple capitalize font-bolder p-20 md:p-0 pt-0 pb-0  text-18 md:text-24 leading-29   '}> some examples</h2>
                      <div className="mt-0 md:mt-30  pt-0 md:pt-10">
                        <ImageSlider
                          slides={[
                            {
                              icon: '/images/design/contact2.svg',
                              title: 'The Vegan Eatery',
                              subtitle: 'Busines card',
                              image: '/images/design/Untitled-18.png',
                            },
                            {
                              icon: '/images/design/contact2.svg',
                              title: 'Friend Telecom ',
                              subtitle: 'Busines card',
                              image: '/images/design/Untitled-19.png',
                            },
                            {
                              icon: '/images/design/pens.svg',
                              title: 'Nur ',
                              subtitle: 'Logo',
                              image: '/images/design/Untitled-20.png',
                            },
                            {
                              icon: '/images/design/pens.svg',
                              title: 'My Geo',
                              subtitle: 'Logo',
                              image: '/images/design/Untitled-21.png',
                            },
                            {
                              icon: '/images/design/car.svg',
                              title: 'Westlakers',
                              subtitle: 'Car wrap',
                              image: '/images/design/Untitled-22.png',
                            },
                            {
                              icon: '/images/design/car.svg',
                              title: 'In Your Corner',
                              subtitle: 'Car wrap',
                              image: '/images/design/Untitled-23.png',
                            },
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                  <div className=" bg-white relative z-10 flex justify-between overflow-hidden bg-text">
                    <ContactUsPart
                      question={'need another logo and branding services?'}
                      link="https://calendar.app.google/uJZkJfztLwHZcfkC7"
                    />
                  </div>
                </Platform>
              </div>
            </div>
          </div>
        </>
        <div className={'mt-60 md:mt-60 '}>
          <LazyLoad>
            <div className="container">
              <h2 className={'uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none '}>How do our Design services work</h2>
              <div className="mt-0 md:mt-30 pt-0 md:pt-30">
                <SimpleSlider
                  width={props.width}
                  processes={[
                    {
                      index: 1,
                      title: 'STARTING POINT',
                      shortened:
                        'After receiving your request, within 24 hours our account manager will reach you, present our proposal  and deadline. The more information you provide about-us-new your needs and business, the more extended and targeted offers we will be able to provide. The information provided by you is 100% confidential.',
                      text: 'After receiving your request, within 24 hours our account manager will reach you, present our proposal  and deadline. The more information you provide about-us-new your needs and business, the more extended and targeted offers we will be able to provide. The information provided by you is 100% confidential.',
                    },
                    {
                      index: 2,
                      title: 'KICKOFF DISCUSSION',
                      shortened:
                        'The first thing we do after the project confirmation  - we try to understand the goal of your company and product, your mission and peculiarities. To save your time we try to get info either via call or questionnaire.  After getting all the needed information, our team starts the research and brainstorming',
                      text: 'The first thing we do after the project confirmation  - we try to understand the goal of your company and product, your mission and peculiarities. To save your time we try to get info either via call or questionnaire.  After getting all the needed information, our team starts the research and brainstorming',
                    },
                    {
                      index: 3,
                      title: 'DEFINING DESIGN REQUIREMENTS ',
                      shortened:
                        'Then based on the provided information our team creates a design requirements document, which defines the structure, features, and purpose of a design that we’re going to create. This enables us to get purpose driven design, where everything is created according to the clients expectations and brand goals.',
                      text: 'Then based on the provided information our team creates a design requirements document, which defines the structure, features, and purpose of a design that we’re going to create. This enables us to get purpose driven design, where everything is created according to the clients expectations and brand goals.',
                    },
                    {
                      index: 4,
                      title: '1ST DRAFT',
                      shortened:
                        'After approval of the structure and design requirements, our production team creates the first draft of the design, which will allow you to understand whether the design meets your expectations or there is a need for certain changes.',
                      text: 'After approval of the structure and design requirements, our production team creates the first draft of the design, which will allow you to understand whether the design meets your expectations or there is a need for certain changes.',
                    },
                    {
                      index: 5,
                      title: 'REVISIONS',
                      shortened:
                        'One of the advantages of our company is the chance of unlimited revisions. If need be, based on the first draft we make the edits according to your requirements until we get a satisfactory final result.',
                      text: 'One of the advantages of our company is the chance of unlimited revisions. If need be, based on the first draft we make the edits according to your requirements until we get a satisfactory final result.',
                    },
                    {
                      index: 6,
                      title: 'FINAL DELIVERY',
                      shortened: '',
                      text: 'This is the final step. We can send your design file in the format of your choice: optimized for your website, social media or anywhere. Also we will give you all source materials for the design, so you can make changes whenever you want.',
                    },
                  ]}
                />
              </div>
            </div>
          </LazyLoad>
          <LazyLoad>
            <div className="bg-gray-light pt-10">
              <h2
                className={
                  'pt-0 md:pt-30 container uppercase text-24 md:text-36 mt-30 md:mt-10 font-black text-purple leading-none  pr-0 md:pr-10   '
                }
              >
                Our Production Team
              </h2>
              <div className="mt-30 container  flex flex-wrap f-full pb-30">
                <div className="w-full xl:w-half mt-0 md:mt-15  md:pr-10">
                  <div className="  text-16  color-black pr-0 md:pr-10">
                    <span className="text-purple font-bold">Passion + Production = Performance</span> - is the formula that guides our in-house team
                    of graphic designers, animators, web developers and sound designers. Everything you need to know about our Production department:
                    13-year professional background, advanced knowledge of 25+ production softwares (Adobe Photoshop, Illustrator, Animator, After
                    Effects, InDesign, Figma, Corel Draw, etc.), numerous designs for 30+ industries, 3 times daily brainstorming and an incessant
                    desire to learn new tools. As an American producer, David O. Selznick says: "The success of a production depends on the attention
                    paid to details," so paying attention to details is the key point of our team's workflow - from sketch to final design. Thus, our
                    production team is ready to contribute to your business and create result- oriented design materials for your brand too.
                  </div>
                </div>
                <div className="w-full xl:w-half mt-20 hidden md:block">
                  <div className="personage   md:w-4/5 lg:w-full h-auto   md:right-0 mt-25  z-10">
                    <picture>
                      <source media="(min-width:768px)" srcSet="/images/design/Team1.webp" type="image/webp" />
                      <source media="(min-width:768px)" srcSet="/images/design/Team1.png" type="image/png" />
                      <source media="(max-width:768px)" srcSet="/images/design/Team1.png" type="image/png" />
                      <img width="600" height="399" src="" alt={'personage'} />
                    </picture>
                  </div>
                </div>
              </div>
              <div className="w-full xl:w-half mt-30 block md:hidden">
                <div className="personage   md:w-4/5 lg:w-full h-auto bottom-0 md:right-0  z-10">
                  <picture>
                    <source media="(min-width:768px)" srcSet="/images/design/Team1.webp" type="image/webp" />
                    <source media="(min-width:768px)" srcSet="/images/design/Team1.png" type="image/png" />
                    <source media="(max-width:768px)" srcSet="/images/design/Teammobile.png" type="image/png" />
                    <img width="100%" height="auto" src="" alt={'personage'} />
                  </picture>
                </div>
              </div>
            </div>
          </LazyLoad>
          <div className="container">
            <LazyLoad>
              <div className="bg-white mt-30 ">
                <div>
                  <p className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">WHY</p>
                  <Why
                    content={[
                      {
                        title: 'We value your time',
                        answer:
                          'We know how important our clients’ time & management resources are, thus outsourcing design services should help to save time. Moreover, we quickly understand your business needs and implement our proven time-saving solutions at all stages of the design process, from communication to payment methods to save your precious time.',
                      },
                      {
                        title: 'We include digital marketing specialists in the design creation process',
                        answer:
                          "Nowadays in the attention hungry era, where marketing is everywhere,  the most crucial point for the business is its catchy and individual design that stands out among competitors and clearly translates brand mission. That's why we include our digital marketing specialists in the design creation process, who study your business requirements in detail and combine them with the requirements of each of the online platforms to get effective material in the end result.",
                      },
                      {
                        title: 'We don’t use templates',
                        answer:
                          'We believe that only as a result of individual, custom, purpose-driven work it is possible to get a material that on the one hand will meet the requirements of the business, and on the other hand will be effective for the target audience. Template materials are a quick and inexpensive solution, but they can not reach your target audience and differentiate you from your competitors. Therefore, saving the time of our clients, we avoid giving solutions with templates and create an on-branded design, where every detail is  purposeful and targeted.',
                      },
                      {
                        title: 'We don’t have a single unhappy client',
                        answer:
                          'For us customer care and fulfilling clients’ expectations are of top priority. Therefore, during the cooperation, we are constantly making optimizations at all stages, so that our clients are satisfied not only with the final result, but also with the whole process of cooperation. That is why after one project 85% of our clients cooperate with us within other projects.',
                      },
                    ]}
                  />
                </div>
              </div>
            </LazyLoad>
          </div>
        </div>
        <LazyLoad>
          <div className="bg-gray-light mt-30  ">
            <div className="container  ">
              <div className="md:flex md:items-center">
                <p className="relative uppercase font-black md:font-bold text-18 md:text-16 text-center text-purple  whitespace-nowrap mb-0   md:mb-0 pt-20 md:pt-13 md:pb-13 md:pr-23 leading-none">
                  Design Softwares we use
                  <span className="hidden md:block absolute top-0 right-0 w-2 h-full bg-gray-dark" />
                </p>
                <div className="grid grid-cols-4 md:grid-cols-8 md:w-full md:ml-23">
                  <div className="client flex items-center">
                    <a rel="noopener noreferrer" className="flex leading-none " href="#">
                      <Image src="/images/design/1.svg" alt="Client1" layout="intrinsic" width="84" height="84" loading="eager" />
                    </a>
                  </div>
                  <div className="client flex items-center">
                    <a rel="noopener noreferrer" className="flex leading-none  " href="#" target="_blank">
                      <Image src="/images/design/2.svg" alt="Client2" layout="intrinsic" width="84" height="84" loading="eager" />
                    </a>
                  </div>
                  <div className="client flex items-center">
                    <a rel="noopener noreferrer" className="flex leading-none  ">
                      <Image src="/images/design/3.svg" alt="Client3" layout="intrinsic" width="84" height="84" loading="eager" />
                    </a>
                  </div>
                  <div className="client flex items-center">
                    <a rel="noopener noreferrer" className="flex leading-none ">
                      <Image src="/images/design/4.svg" alt="Client5" layout="intrinsic" width="84" height="84" loading="eager" />
                    </a>
                  </div>
                  <div className="client flex items-center">
                    <a rel="noopener noreferrer" className="flex leading-none ">
                      <Image src="/images/design/affinity.svg" alt="Client5" layout="intrinsic" width="84" height="84" loading="eager" />
                    </a>
                  </div>
                  <div className="client flex items-center">
                    <a rel="noopener noreferrer" className="flex leading-none ">
                      <Image src="/images/design/7.svg" alt="Client8" layout="intrinsic" width="84" height="84" loading="eager" />
                    </a>
                  </div>
                  <div className="client flex items-center">
                    <a rel="noopener noreferrer" className="flex leading-none  ">
                      <Image src="/images/design/5.svg" alt="Client7" layout="intrinsic" width="84" height="84" loading="eager" />
                    </a>
                  </div>
                  <div className="client flex items-center">
                    <a rel="noopener noreferrer" className="flex leading-none  ">
                      <Image src="/images/design/6.svg" alt="Client8" layout="intrinsic" width="84" height="84" loading="eager" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LazyLoad>
        <LazyLoad>
          <div className="bg-white bg-grid ">
            <div className="relative">
              <div className="flex flex-col-reverse md:flex-row">
                <div
                  className="bg-fixed fix-elem  w-full  lg:w-40p bg-purple bg-center bg-cover pt-15 md:pt-0  min-h-460 md:h-537 relative"
                  style={{ backgroundImage: `url(/images/smm/texture.png)` }}
                >
                  <div className={'absolute right-0 md:-right-150 bottom-0 z-50'}>
                    <div className="absolute animationBehance">
                      <div className="text-animation">
                        <span>B</span>
                        <span class="relative">
                          e <span className="logo-line">-</span>
                        </span>
                      </div>
                    </div>
                    <picture>
                      <source media="(min-width:768px)" srcSet="/images/design/Anna.webp" type="image/webp" />
                      <source media="(max-width:768px)" srcSet="/images/design/Anna.webp" type="image/png" />
                      <img
                        width={props.width < 768 ? 410 : 410}
                        height={props.width < 768 ? 427 : 427}
                        src=""
                        className="hide"
                        alt={'personage  Anna'}
                      />
                    </picture>
                  </div>
                </div>
                <div className="w-auto md:w-full pb-30 md:pb-0  lg:w-60p h-auto md:h-537 flex flex-col justify-start md:justify-center items-start md:items-center ml-30 md:ml-0 mt-30 md:mt-0 ">
                  <div className={'text-36 md:text-48 leading-35 md:leading-59 font-black uppercase'}>
                    <span className={'text-purple'}>We are on</span> <br /> behance
                  </div>
                  <div className="mt-12 h-40 w-154">
                    <span className="perspective-1000 contact">
                      <a href="https://www.behance.net/weprodigiagency" target="_blank" className={' findUs  inline-block '}></a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LazyLoad>
        <Proposal
          show={showProposal}
          hide={() => {
            setShowProposal(false);
            document.documentElement.style.overflow = 'auto';
          }}
          title={title}
          country={props.country}
        />
        <DesignCalculator
          show={showCalc}
          hide={() => {
            setShowCalc(false);
            document.documentElement.style.overflow = 'auto';
          }}
        />
      </main>
    </>
  );
};
export default Design;
